/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect, CSSProperties } from 'react';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import MainMenu from '../GetStarted/MainMenu';
import LowerMenu from '../GetStarted/LowerMenu';
import { Form, InputGroup, Row,Container,Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Typography,
  Button,
  IconButton,
  TextField,
  Checkbox,
  Box,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  CardActions,
  CardMedia,
  List, ListItem, ListItemText, ListItemAvatar, Avatar,Card,CardHeader, CardActionArea, CardContent
} from "@material-ui/core";
import { InputAdornment,OutlinedInput,InputLabel,FormControl, FormLabel, FormGroup} from '@mui/material';
import Grid from '@mui/material/Grid';
import { Alert } from '@mui/material';
import Snackbar from '@material-ui/core/Snackbar';

import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import Footer from './Footer';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
//import GroupAddIcon from '@mui/icons-material/GroupAdd';
//import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import BlockIcon from '@mui/icons-material/Block';
//import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { Formik, Field, ErrorMessage   } from 'formik';
import { FormValidationSchema } from './ValidationSchema';
import { currentDate,uniqueServiceFormID } from '../../utils/currentDate';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Axios from 'axios';
import Swal from "sweetalert";
import { fontFamily, fontSize } from '@mui/system';
import CloseIcon from '@material-ui/icons/Close';
import Page from '../../components/Page';
import { createTheme } from '@material-ui/core/styles'

import { Accordion, AccordionItem } from 'react-light-accordion';
import 'react-light-accordion/demo/css/index.css';

import PrivacyPolicyContent from './PrivacyPolicy';
import { branches } from '../../utils/branches'
import { Signature,Encryption,Countries,PrivacyInformation } from '../../utils/index'
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Fab from '@material-ui/core/Fab';
import './BacktoTop.css';
import { useFormikContext } from 'formik';
//import 'bootstrap/dist/css/bootstrap-grid.css';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CircularProgress from '@mui/material/CircularProgress';
import { idTypes } from '../../utils/data';
import VerifiedIcon from '@mui/icons-material/Verified';
import SignatureCanvas from 'react-signature-canvas';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Tooltip from '@mui/material/Tooltip';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';
import EuroIcon from '@mui/icons-material/Euro';
import LockResetIcon from '@mui/icons-material/LockReset';
import AppBlockingIcon from '@mui/icons-material/AppBlocking';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Menu from '@mui/material/Menu';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    //flexWrap: "wrap",
    "& > *": {
      marginTop:theme.spacing(0),
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3),
    },
    fontFamily: 'Helvetica , sans-serif'
  },
  selectCard: {
    marginTop: theme.spacing(1),
    backgroundColor: "#ffffff",
    border: '1px solid #000000'
  },
  centeritem:{
    textAlign: 'center',
    //fontSize:22,
    //fontFamily:'Roboto'
  },
  footer:{
  bottom:0,
  },
  paragraph:{
    fontSize:16,
    
    
  },
  checkbox:{
    marginRight: theme.spacing(1),
    width:18,
    height:18
  },
  radiobutton:{
    marginLeft: theme.spacing(1),
    width:18,
    height:18
  },
  policyError: {
    color: colors.red[400],
    fontSize: 12,
  },
  formValue: {
    fontSize: 14,
    //fontWeight: 600,
    // flex: 1,
    color: colors.grey[900],
    border: 0,
    resize: 'none',
    overflow: 'hidden',
    padding: '-70px',
    backgroundColor: "#F4F6F8",
    maxWidth: '100%'
  },

  
  customer_header:{
    color:'#000000',
    backgroundColor: colors.lime[500],
    fontSize:16,
    //width:'100%'
    
  },
  textLower: {
    textTransform: 'lowercase',
    fontWeight: 500,
    fontSize: 12,
    color:'white'
  },
  grid_header:{
    color:'#000000',
    backgroundColor: '#61dafb',
    fontSize:16,
    //fontFamily: 'Roboto'
  },
  mandatory:{
    color:'red',
    fontSize:12,
    textTransform: 'lowercase',
    fontWeight: 500,
  },
  grid_background:{
    backgroundColor:'#ffffff',
  },
  tickSize: {
    transform: "scale(1.5)",
  },
  
  table: {
    minWidth: 650
  },
  tableRow: {
    height: 10
  },
  tableCell: {
    padding: "0px 16px"
  },
  highlight:{
    backgroundColor:'#ffffff',
    fontSize: 14,
    //fontWeight: 600,
    border: 1,
    resize: 'none',
    overflow: 'hidden',
    marginTop: 25,
    marginLeft: 10,
  },

  card: {
    //background: 'linear-gradient(100deg, #61dafb 30%, #ffffff 90%)',
    color: '#000000',
  },
  readonly:{
    backgroundColor:'#f2f2f2',
    fontSize:14,
    paddingRight:5
  },

grid: {
    paddingLeft: 0,
    paddingRight: 0
},
row: {
    marginLeft: 0,
    marginRight: 0
},
col: {
    paddingLeft: 0,
    paddingRight: 0
},
formControl: {
  width: '100%', // Set width to 100%
},
formTitle: {
  // color: "#FFFFFF",
  color: colors.lightBlue[600],
  marginLeft: theme.spacing(),
  flex: 1,
  fontWeight: 600
},

details: {
  color: colors.grey[900],
  backgroundColor: colors.lime[500],
  display: 'flex',
  justifyContent: 'flex-start',
  fontWeight: 800,
  
},
activeTab: {
      // Styles for non-selected tabs
      '&:not(.Mui-selected)': {
        color: '#000000', // Change to your desired non-selected color
        fontWeight: 800,
      },
  
      // Styles for selected tab
      '&.Mui-selected': {
        fontWeight: 800,
        borderRadius:10,
        //backgroundColor: 'rgb(0,173,238)',
        color: '#000000'
      },
      color: '#000000'
      
},



centeredTabs: {
  display: 'flex',
  justifyContent: 'center', // Center the tabs horizontally
},


activeCard: {
  border: '3px solid rgb(0,173,238)',
  backgroundColor:"#ffffff",
  
},
icon: {
    //position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    color: 'rgb(0,173,238)',
},

label:{
  color: '#000000'
},

}))

//List of the different PostBank Debit Card options.
const debitCardOptions=[
  'First Issue (Not received)',
  'Damaged',
  'Expired',
  'Lost', 
]

//List of the different PostMobile options
const postMobileOptions=[
  'PIN Reset',
  'Device Change Reset',
]
//Post online options
const postOnlineOptions=[
  'PIN Reset',
  'Disable',
]
//Post E-statement
const estatementOptions=[
'Weekly', 'Monthly'
]

const atmCardLimitsOptions=[{"name":"Classic Card UGX 5 million", "nameValue":"Classic Card UGX 5 million"},{"name":"Platinum UGX 10 million", "nameValue":"Platinum UGX 10 million"},{"name":"Prepaid Card UGX 10 million", "nameValue":"Prepaid Card UGX 10 million"}];

const chequeBookCurrencyOptions=[
  'UGX','KES','USD', 'EUR', 'GBP'
]

//Number of cheque books options
const chequebooksOptions=[
  25, 50, 100
]
//The options for the Reasons of stop payment
const stoppayReasons=[
  'Lost','Misplaced'
]

//Blocking ATM Card Reasons
const blockATMCardReasonOptions=[
  'Damaged', 
  //'Expired', 
  'Lost'
]

//This holds all the content of the self service requests.
function SelfServiceContent() {
//Working on the dialog for the form preview
const [open, setOpen] = useState(false);

const handleClickOpen = (e) => {  
  setOpen(true); 
};

//loading button state
const [loading, setLoading] = useState(false);

  const classes =  useStyles();
  const textAreaRef = useRef(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');

  const copyCodeToClipboard = (e) => {
    e.preventDefault();
    textAreaRef.current.select();
    document.execCommand('copy');
    setCopySuccess('Copied!');
    setSnackOpen(true);
    e.preventDefault();
  }

  const formik = useFormikContext();

  const displayFormikErrors = () => {
    // Manually trigger form validation
    const errors = formik.validateForm();
    formik.setErrors(errors);
  };

  function getCurrentTime() {
    var currentTime = new Date();
    var hours = currentTime.getHours();
    var minutes = currentTime.getMinutes();
    //var seconds = currentTime.getSeconds();
  
    // Add leading zeros if necessary
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    /*if (seconds < 10) {
      seconds = '0' + seconds;
    }*/
  
    // Return the formatted time string
    return hours + ':' + minutes // + ':' + seconds;
  }
  
  //Accessing Formik values
  const ref = useRef(null);
  //Function to handle the data submission to via an API.
  const [isSubmitting, setIsSubmitting] = useState(false);

  //const[formValues, setFormValues]=useState([]);
  //Using the existing encryption constants
  const query = "KYC";
  const {timestamp, signatureValue} = Signature(query)
  const config = {
    headers: {
      // "signature": process.env.REACT_APP_SIGNATURE,
      "signature": `${signatureValue}`,
      // "signature": '4056fb7dd7bde7e120ca3148b50b4264658248330806f873fa884c56dd1ccdd9',
      "Content-Type": 'application/json;charset=UTF-8',
      // "keep-alive": false,
    }
  };
  //Handling Image Upload state
  const [frontImageString, setfrontImageString]= useState(""); //front image
  const [backImageString, setbackImageString]= useState(""); //back image
  const [signatureImageString, setsignatureImageString]= useState("");//signature image
  const [previewFrontImage, setPreviewFrontImage] = useState(null);
  const [previewBackImage, setPreviewBackImage] = useState(null);
  const [previewSignatureImage, setPreviewSignatureImage] = useState(null);
  const [selectedFrontImage, setSelectedFrontImage] = useState(null);
  const [selectedBackImage, setSelectedBackImage] = useState(null);
  const [selectedSignatureImage, setSelectedSignatureImage] = useState(null);

  const handleImageUploadFront = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewFrontImage(file);  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewFrontImage(imageUrl);
      setSelectedFrontImage(imageUrl);
      ref.current.values.frontImageValueHolder = imageUrl;  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setfrontImageString(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setfrontImageString("");
      setPreviewFrontImage(null);
      ref.current.values.frontImageValueHolder = "";
    }
  };
  

  
const handleImageUploadSignature = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewSignatureImage(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewSignatureImage(imageUrl);
      setSelectedSignatureImage(imageUrl);
      ref.current.values.signatureImageValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setsignatureImageString(base64Image)
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setsignatureImageString("");
      setPreviewSignatureImage(null);
      ref.current.values.signatureImageValueHolder = "";
    }
  };

  const handleImageUploadBack = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewBackImage(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewBackImage(imageUrl);
      setSelectedBackImage(imageUrl);
      ref.current.values.backImageValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setbackImageString(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setbackImageString("");
      setPreviewBackImage(null);
      ref.current.values.backImageValueHolder = "";
    }
  };
  

  
  //The submit function with encryption
  //let [loading, setLoading] = useState(true);
  const handleSubmit = async () =>{
    setLoading(true);
    console.log("The front image string:"+signatureImageString)
    let values = {
      "formID":ref.current.values.formID,
      "accountNumber": ref.current.values.accountNumber,
      "accountName": ref.current.values.accountName,
      "idType":ref.current.values.idType,
      "idNumber": ref.current.values.idNumber,
      "emailAddress": ref.current.values.emailAddress,
      "requestDate": ref.current.values.requestDate,
      "branchOfApplication": ref.current.values.branchOfApplication,
      "mobilePhoneNumber":ref.current.values.countryCode+ref.current.values.mobilePhoneNumber,
      "timeOfRequest": ref.current.values.timeOfRequest,
      "policy": ref.current.values.policy,
      "limitAmount": ref.current.values.limitAmount,
      "numberOfChequeBooksUGX": ref.current.values.numberOfChequeBooksUGX,//for number of chequebooksUGX
      "numberOfChequeBooksKES":ref.current.values.numberOfChequeBooksKES,//for number of chequebooksKES
      "numberOfChequeBooksUSD":ref.current.values.numberOfChequeBooksUSD,//for number of chequebooksUSD
      "numberOfChequeBooksEUR":ref.current.values.numberOfChequeBooksEUR,//for number of chequebooksEUR
      "numberOfChequeBooksGBP":ref.current.values.numberOfChequeBooksGBP,//for number of chequebooksGBP
      "stoppaymenttime": ref.current.values.stoppaymenttime,
      "stopPaymentReason": ref.current.values.stopPaymentReason,
      "chequeNumberRange": ref.current.values.chequeNumberRange,
      "postbankdebitcard": ref.current.values.postbankDebitCard,
      "postMobile":ref.current.values.postMobile.toString(),//to be uncommented
      "postonline": ref.current.values.postOnline,
      "status":"NEW",
      "blockATMCardReason":ref.current.values.blockATMCardReason,
      "frontImage":frontImageString,
      "backImage":backImageString,
      //"signatureRefValue":signatureRefValue
      "signatureRefValue":signatureImageString
      
    };
    const apiUrl = `${window.location.origin}/api/KYC/createservicerequest`;//production
    //console.log("The Phone Number is "+ ref.current.values.countryCode+ref.current.values.mobilePhoneNumber);
    //const apiUrl = 'http://localhost:46087/KYC/createservicerequest'; //local
    //const apiUrl = 'http://10.129.2.15:9092/KYC/createservicerequest'; //remote uat
    const objValues = {
      //"username": "KYCUI-TEST",
      "username": "KYCUI-TEST",
      "applicationID": "KYCUI",
      "where": values,
      "action": "SAVE_DETAILS",
      "query": "KYC",
      "timestamp":`${timestamp}`
      // "encryptCols":["accountName", "accountNumber", "cardNumber", "branch", "email", "phone"]
    }
    //console.log("This is the signature value: "+ signatureRefValue);
    const hashedObjValues = Encryption(JSON.stringify(objValues));
    //console.log(">>>", hashedObjValues)
    //console.log("The front image string is "+frontImageString)
    //console.log("The back image string is "+backImageString)
    await Axios.post(apiUrl, hashedObjValues, config).then(res=>{
      if (res.data.response_message === "Service Request Details Saved Successfully") {
       //(res.data.response_message);
       //refreshPage();       
       Swal({
        title: "Successful SelfCare request",
        text: "Your reference number is "+ref.current.values.formID+" and has been sent to the phone number/email Address you provided in the form",
        icon: "success",
        button: "Ok",
      });      
      setLoading(false);
      handlePreviewClose();
      //Refresh the page after submission.
      //Clearing all the values once the submission is successful
      refreshPage(6); //Refresh the page after 6 seconds.
      }else{
      //console.log(res.data.response_message);
      Swal({
        title: "Request Failed",
        text: res.data.response_message,
        icon: "error",
        button: "Ok",
      });  
      setLoading(false);    
      }
    }).catch((error) => {
      //console.log(error);
      Swal({
        title: "Something went wrong",
        text: "Contact the Administrator",
        icon: "error",
        button: "Ok",
      });
      setLoading(false);
    });
  }

  //Copy Form ID
  
  const handleCloseSnack = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false)
  }

  /**
   * Handle the Accept terms and conditions checkbox
   */
  const [checked, setChecked] = useState(false);
  
  //This handles the terms and conditions dialogue
//Add an alert to display when the user chooses to reject the terms and conditions
const [openAlert, setOpenAlert] = useState(false);
const handleAlertClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpenAlert(false);
};

const handleClose = () => {
  setOpen(false);
  //setChecked(false);
  //Add an alert 
};
const handleCloseAndAccept = () => {
  setOpen(false);
  setChecked(true);
};
  const handleTermsCheck = (event) => {
    setChecked(event.target.checked);
    setOpen(event.target.checked);  
    setOpenAlert(true);
  };

  //An alert for the informative message that guides the clients
  const [openInfoAlert, setOpenInfoAlert] = useState(true);
  const handleInfoAlertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenInfoAlert(false);
  };
  //const [isCurrencyChecked, setIsCurrencyChecked] = useState(false);
  
  //This handles the preview dialog
  const [previewOpen, setPreviewOpen] = useState(false);

  const [buttonClick, setButtonClick] = useState(false);
  const previewDialogClick=()=>{
    setButtonClick(!buttonClick);
    setPreviewOpen(true); 
  }
  const handlePreviewClose = () => {
    setPreviewOpen(false);
    //setChecked(false);
  };

  //Modal to guide the user when they load the app
  const [isOpen, setIsOpen] = useState(false);
  //const [loading, setLoading] = React.useState(true);
  const [hideTextField, setHideTextField]= useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  //Creating a snack alert for the errors
  const [openErrors, setOpenErrors] = useState(false);
  const handleCheckErrors = () => {
    setOpenErrors(true);
  };
  const handleCloseErrors = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrors(false);
  };

  //Refresh the page after form submission
  function refreshPage(seconds) {
    setTimeout(function() {
      alert("Submission has been successfull");
      window.location.reload(); // Refresh the page
    }, seconds * 1000); // Convert seconds to milliseconds
  }
  //ADDING A DIGITAL SIGNATURE TO A FORM
  const signatureRef = useRef('');
  const [signatureRefValue, setSignatureRefValue]= useState('');
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignatureRefValue('');
    ref.current.values.digitalSignatureValueHolder="";
    //console.log("The signature has been cleared");

  };
  const [previewDigitalSignature, setPreviewDigitalSignature] = useState(null);
  const handleSendSignature = () => {
    //console.log("Into handle signature method");
    if (signatureRef.current) {
      const base64ImageSignature = signatureRef.current.toDataURL('image/png').replace(/^data:image\/png;base64,/, 'data:application/octet-stream;base64,');
      setPreviewDigitalSignature(base64ImageSignature);
      //console.log(base64ImageSignature);
      setSignatureRefValue(base64ImageSignature);
      ref.current.values.digitalSignatureValueHolder=base64ImageSignature; 
    }else{
      //console.log("Failed to handle signature");
      ref.current.values.digitalSignatureValueHolder="";
    }
  };


  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

 

  //List of all services
  const digitalServices=[
    'PostBank Debit Card Replacement', 'Block My ATM Card', 'PostOnline Services',
    'ATM Card Limit Enhancement', 'Post Mobile Services','ChequeBooks UGX', 'ChequeBooks KES','ChequeBooks USD',
    'ChequeBooks EUR', 'ChequeBooks GBP','Stop Payment'
  ]

  //List of ChequeBook Services
  const chequeBookServices=[
    'ChequeBooks UGX', 'ChequeBooks KES','ChequeBooks USD',
    'ChequeBooks EUR', 'ChequeBooks GBP','Stop Payment'
  ]
  return (   
    <Grid fluid style={{ padding:10 }}>
    {/*<GuideModal/>*/}
    <div className="fab-container">
      <Fab color="primary" className="fab-button" onClick={handleCheckErrors}>
        Help
      </Fab>
    </div>
    <Typography
      color="textPrimary"
      variant="h5"
      className={classes.formTitle}
      flexGrow={2}
    >Self-Serve Form
    </Typography>
      {/**Grid for customer infromation form */}
      <Formik
       //Declaring all the form input field initial values.
            initialValues={{
              formID:uniqueServiceFormID(),
              accountNumber: "",
              accountName: "",
              idNumber: "",
              emailAddress:"",
              requestDate: currentDate(),
              postbankDebitCard: "",
              postMobile:[],
              postOnline:"",
              branchOfApplication: "",
              countryCode:"256",
              mobilePhoneNumber: "",
              timeOfRequest: getCurrentTime(),
              policy:false,
              estatement:"",
              //limitEnhancement:[],//This has been ignored due to client changes
              limitAmount:"",
              //chequebookscurrency:[],
              //Breaking the number of cheque books into individual elements start.
              numberOfChequeBooksUGX:"",
              numberOfChequeBooksKES:"",
              numberOfChequeBooksUSD:"",
              numberOfChequeBooksEUR:"",
              numberOfChequeBooksGBP:"",
              //breaking the number of cheque books into indual elements end
              stoppaymenttime:"",
              stopPaymentReason: "",
              chequeNumberRange: "",
              //Added the block my atm card reason.
              blockATMCardReason:"",
              idType:"",
              frontImageValueHolder: "",
              backImageValueHolder:"",
              signatureImageValueHolder: "",
              //previewFrontImage:null,
              //Array that holds all the selection values
              //options: []
              //digitalSignatureValueHolder: ""
            }}            
            validationSchema={FormValidationSchema}
            //isInitialValid={() => FormValidationSchema.isValidSync(initialValues)}
            //onSubmit={handleSubmit}
            //enableReinitialize
            innerRef={ref}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              // handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              touched,
              values,
            }) => {
              //Determing the number of digits entered for both the account number input and the id number input
              const accNoLength = values.accountNumber.toString().length === 0 ? '' : values.accountNumber.toString().length;
              const idNoLength = values.idNumber.toString().length === 0 ? '' : values.idNumber.toString().length;
              return(
        <form onSubmit={handleSubmit}>
          <Row>
          <Col xs={12} md={6}> 
          {/**To hold the alert that appears ob rejecting the terms and conditions
           */}
          <Snackbar open={openAlert} autoHideDuration={4000} onClose={handleAlertClose}>
            <Alert onClose={handleAlertClose} severity="error">
              <Typography>You won't be able to proceed if you dont agree to the terms and condition.</Typography>
            </Alert>
          </Snackbar>
          {/**Snack bar to hold all the form Errors*/}
          <Snackbar open={openErrors} autoHideDuration={8000} onClose={handleCloseErrors}>
            <Alert onClose={handleCloseErrors} severity="info" variant="filled" color="info">
            {errors && Object.keys(errors).length > 0 && (
              <>
                {Object.values(errors).map((error) => (
                  <ListItem>{error}</ListItem>
                ))}
              </>
             )}
             <ListItem>Confirm that you have selected the appropriate service(s) among (Digital Banking, Cheque book request, or Stop Payment) sections</ListItem>
            </Alert>
          </Snackbar>
          <Dialog
          open={openInfoAlert}
          onClose={handleInfoAlertClose}
          >
            <Alert open={openInfoAlert} severity="info" variant="filled" onClose={handleInfoAlertClose}>The Self Serve form below can be used to make the following requests; ATM card replacement, ATM card blocking, ATM Card Limit Enhancement, Pin reset, device change request, cheque book request and stop payment request. Please select the most appropriate service required.</Alert> 
          </Dialog>       
          {/* Submit button */}
             
          </Col>
          </Row>
          {/**Row to hold the first two records of the form. */}
          <Row>          
          <Col xs={12} md={12}>
          <Button variant="contained" fullWidth className={classes.details}><PersonOutlineIcon />&nbsp;CUSTOMER INFORMATION<span className={classes.mandatory} >&nbsp;*</span></Button>
          {hideTextField &&(
            <TextField
            error={Boolean(touched.requestDate && errors.requestDate)}
            helperText={touched.requestDate && errors.requestDate}
            label= "Request Date"
            type="date"
            margin="normal"
            name="requestDate"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.requestDate}
            InputLabelProps={{
              shrink: true,
            }}
            format={'DD/MM/YYYY'}
            size="small"
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            //className={classes.textField}
            required
            readOnly
            />)}
            {/*<Typography className={classes.formTitle}>SelfCare Form</Typography>*/}        
          </Col>
          
          {hideTextField&&
          <Col xs={12} md={6}>
          <TextField
              fullwidth
              error={Boolean(touched.timeOfRequest && errors.timeOfRequest)}
              helperText={touched.timeOfRequest && errors.timeOfRequest}
              label= "Request Time"
              margin="normal"
              name="timeOfRequest"
              type="text"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.timeOfRequest}
              size="small"
              variant="outlined"
              required
              InputProps={{
                readOnly: true,
              }}
              readOnly
          />
          
          </Col>

          }
          </Row>

      {/*<Button variant="contained" fullWidth className={classes.customer_header}><PersonOutlineIcon />&nbsp;Customer Information <span className={classes.mandatory} >*</span></Button>*/}

      <Row >  
     
        <Col xs={12} md={6}>
        <FormControl fullWidth sx={{ m: 0 }} >
          <label>{`Account Number ${(accNoLength)}`}<span className={classes.mandatory} >&nbsp;*</span></label>
          <TextField 
            fullWidth
            error={Boolean(errors.accountNumber)}
            //className={classes.margin}
            helperText={errors.accountNumber}
            //label={`Account Number ${accNoLength}`}
            placeholder="1266273828199"
            type="text"
            margin="normal"
            name="accountNumber"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.accountNumber}
            variant="outlined"
            size="small"
            required
          />
        </FormControl>
        </Col>
        
        <Col xs={12} md={6}>
        <FormControl fullWidth
        >
          <label>Account Names<span className={classes.mandatory} >&nbsp;*</span></label>
          <TextField
            fullWidth
            error={Boolean(errors.accountName)}
            helperText={errors.accountName}
            //label= "Account Names"
            placeholder="Daniel Mukasa"
            type="text"
            margin="normal"
            name="accountName"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.accountName}
            variant="outlined"
            size="small"
            required
          />
        </FormControl>
        </Col>
        <Col xs={12} md={6}>
        <FormControl fullWidth>
        <label>Email Address</label>
        <TextField
            fullWidth
            error={Boolean(errors.emailAddress)}
            helperText={errors.emailAddress}
            //label= "Email Address"
            placeholder='test@email.com'
            type="text"
            margin="normal"
            name="emailAddress"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.emailAddress}           
            variant="outlined"
            size="small"
            required
        />
        </FormControl>
        </Col>
        <Col xs={12} md={6}>
        <FormControl fullWidth>
          
      <label>Select the Country Code and then enter the Telephone number <span className={classes.mandatory} >&nbsp;*</span></label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
      <Select
        //style={{ padding: 4}}
        value={values.countryCode}
        onChange={handleChange}
        onBlur={handleBlur}
        name="countryCode"
        size="small"
      >
        <MenuItem key='' value='256'>
            Uganda (256)<span className={classes.mandatory} >&nbsp;*</span>
        </MenuItem>
        {Countries.map((country) => (
          <MenuItem key={country.dial_code} value={country.dial_code}>
            {country.name} ({country.dial_code})
          </MenuItem>
        ))}
      </Select>
      &nbsp;
      <TextField
        style={{ padding:4}}
        fullWidth
        //error={Boolean(errors.mobilePhoneNumber)}
        //helperText={errors.mobilePhoneNumber}
        margin="normal"
        name="mobilePhoneNumber"
        placeholder="7XXXXXXXX"
        onBlur={handleBlur}
        onChange={handleChange}
        value={values.mobilePhoneNumber}
        variant="outlined"
        size="small"
        required
        disabled={!values.countryCode}
        InputProps={{ inputProps: { minLength: 9 } }}
      />
      </div>
        </FormControl>   
        </Col>

        {/**Adding the ID Selection */}
        <Col xs={12} md={6}>
        <FormControl fullWidth>
          <label>ID Type<span className={classes.mandatory} >&nbsp;*</span></label>
          <Select
            error={Boolean(errors.idType)}
            className={classes.halftextField}
            //label="Select ID Type"
            name="idType"
            onChange={handleChange}
            required
            helperText={errors.idType}
            select
            placeholder="Select ID Type"
            SelectProps={{ native: true }}
            value={values.idType}
            variant="outlined"
            margin="normal"
            onBlur={handleBlur}
            size="small"
          >
            {idTypes.map((type, index) => (
              <MenuItem
                key={index}
                value={type.label}
              >
                {type.label}
              </MenuItem>
            ))}
          </Select>
        <small className={classes.policyError}><ErrorMessage name="idType" /></small> 
        </FormControl>
        </Col>
        {values.idType &&<Col xs={12} md={6}>
        <FormControl fullWidth>
          <label>{`ID Number ${idNoLength}`}<span className={classes.mandatory} >&nbsp;*</span></label>
          <TextField
            fullWidth
            error={Boolean(errors.idNumber)}
            helperText={errors.idNumber}
            //label={`ID Number ${idNoLength}`}
            placeholder="CM252617282910"
            margin="normal"
            name="idNumber"
            onBlur={handleBlur}
            onChange={(event) => {
              const capitalizedValue = event.target.value.toUpperCase();
              handleChange(event.target.name)(capitalizedValue);
            }}
            value={values.idNumber}
            variant="outlined"
            size="small"
            required
        />
        </FormControl>
        </Col>
        }
        {
          values.idType &&
          <Col xs={12} md={6}>
          <Card className={classes.selectCard} style={{ display: 'flex' }}>
            <CardContent style={{ marginRight: 'auto' }}>
              <FormControl //className={classes.formControl}
              >
              <label component="legend">Attach the {values.idType} Front face<span className={classes.mandatory} >&nbsp;*</span></label>
                  <TextField 
                    type="file" 
                    onChange={handleImageUploadFront} 
                    onBlur={handleBlur}
                    className="file-input" 
                    accept="image"
                    error={Boolean(errors.frontImageValueHolder)}
                    helperText={errors.frontImageValueHolder}
                    name="frontImageValueHolder"
                  />
                  
              </FormControl>
            </CardContent>
            {previewFrontImage && 
              <CardMedia
                component="img"
                src={previewFrontImage}
                alt="Front image"
                //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                style={{ width: '200px', height: '110px', objectFit: 'cover' }}
              />    
            }
          </Card>
          </Col>
        }

        {
          values.idType &&
          <Col xs={12} md={6}>
          <Card className={classes.selectCard} style={{ display: 'flex' }}>
            <CardContent style={{ marginRight: 'auto' }}>
              <FormControl>
              <label component="legend">Attach the {values.idType} Back face<span className={classes.mandatory} >&nbsp;*</span></label>
                  <TextField 
                  type="file" 
                  onChange={handleImageUploadBack} 
                  onBlur={handleBlur}
                  className="file-input" 
                  accept="image" 
                  error={Boolean(errors.backImageValueHolder)}
                  helperText={errors.backImageValueHolder}
                  name="backImageValueHolder"
                  />
              </FormControl>
            </CardContent>
            {previewBackImage && 
                <CardMedia
                  component="img"
                  src={previewBackImage}
                  alt="Back Image"
                  //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                  style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                  required
                />
            }
          </Card>
          </Col>
        }
        {
          values.idType &&
          <Col xs={12} md={6}>
          <Card className={classes.selectCard} style={{ display: 'flex' }}>
            <CardContent style={{ marginRight: 'auto' }}>
              <FormControl>
              <label component="legend">Attach the Signature Photo<span className={classes.mandatory} >&nbsp;*</span></label>
                  <TextField 
                  type="file" 
                  onChange={handleImageUploadSignature} 
                  onBlur={handleBlur}
                  className="file-input" 
                  accept="image" 
                  error={Boolean(errors.signatureImageValueHolder)}
                  helperText={errors.signatureImageValueHolder}
                  name="signatureImageValueHolder"
                  />
              </FormControl>
            </CardContent>
            {previewSignatureImage && 
                <CardMedia
                  component="img"
                  src={previewSignatureImage}
                  alt="Signature"
                  //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                  style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                  required
                />
            }
          </Card>
          </Col>
        }
      </Row>
      <br/>
      {/**ADDING THE TABBED LAYOUT FOR THE SERVICES */}
      <div>.
      <Button variant="contained" fullWidth className={classes.details}><AccountBalanceIcon />&nbsp;DIGITAL BANKING AND CHEQUE BOOK SERVICES<span className={classes.mandatory} >&nbsp;*</span></Button>
      <Alert severity="info" className={`${classes.snackFont}`}>
        <em><small>Select the appropriate Digital Banking Services or Cheque Book Service</small></em>
      </Alert>
      <div>  
        <br/>      
          <div>
          <Row>
            <Col>
              <FormControl fullWidth>
              {/*<label component="legend">Choose the appropriate Digital Banking Services<span className={classes.mandatory} >&nbsp;*</span></label>*/}
              <Select
                fullWidth
                error={Boolean(errors.digitalServices)}
                name="digitalServices"
                onChange={handleChange}
                onBlur={handleBlur}
                required
                margin='normal'
                helperText={errors.digitalServices}
                select
                SelectProps={{ native: true }}
                value={values.digitalServices}
                variant="outlined"
                id="elmt"
                size="small"
                placeholder="Choose here"
                //adding the prop to change the size of the text field
              >
                <MenuItem
                  key=''
                  value=''
                  //disabled
                >
                  Choose a service of your choice 
                </MenuItem>
                {digitalServices.map((service, index) => (
                  <MenuItem
                    key={index}
                    value={service}
                  >
                    <em><b>{service}</b></em>
                  </MenuItem>
                ))}
              </Select>
              </FormControl>
            </Col>
          </Row>
          <Row>
            {
              values.digitalServices==='PostBank Debit Card Replacement' &&
              <Col xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.postbankDebitCard !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
                <CreditCardIcon/>
                <CardContent style={{ marginRight: 'auto', paddingBottom: '1' }}>
                <p>1. PostBank Debit Card Replacement</p>
                <FormControl fullWidth>                         
                      <Select
                        error={Boolean(errors.postbankDebitCard)}
                        margin="normal"
                        //label="Preferred Branch"
                        name="postbankDebitCard"
                        //onChange={handleChange}
                        onChange={(event) => {
                          handleChange(event);
                          //setSelectedOption(event.target.value);
                        }}
                        helperText={errors.postbankDebitCard}
                        select
                        //input={<TextField variant="outlined" />}
                        SelectProps={{ native: true }}
                        value={values.postbankDebitCard}
                        variant="outlined"
                        id="elmt"
                        size="small"
                        //placeholder="Reason for replacement"
                      >
                        <MenuItem key='' value=''>
                        Specify replacement reason
                        </MenuItem>
                        {debitCardOptions.map((cardoptions, index) => (
                            <MenuItem key={index} value={cardoptions}>
                              {cardoptions}
                            </MenuItem>
                        ))}
                      </Select>
                      <small className={classes.mandatory}>{errors.postbankDebitCard}</small>
                </FormControl>
              
                </CardContent>
                {values.postbankDebitCard && 
                  <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
              </Card>
              </Col>
            }

            {
              values.digitalServices==='Block My ATM Card' &&
            <Col xs={12} md={12} >
            <Card className={`${classes.selectCard} ${values.blockATMCardReason !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
              {/*<h6><b>2. Block My ATM Card <small>(specify reason...)</small></b></h6>*/}
              <BlockIcon/>
              <CardContent style={{ marginRight: 'auto' }}>
                  <FormControl fullWidth className={classes.formControl}
                  >
                    <label><h6>2. Block My ATM Card (Specify the reason)</h6></label>
                    <Select
                      //label="Block My ATM Card (specify reason...)"
                      margin="normal"
                      error={Boolean(errors.blockATMCardReason)}
                      name="blockATMCardReason"
                      onChange={handleChange}
                      helperText={errors.blockATMCardReason}
                      select
                      SelectProps={{ native: true }}
                      value={values.blockATMCardReason}
                      variant="outlined"
                      id="elmt"
                      size="small"
                      fullWidth
                    >
                      <MenuItem key='' value=''>
                      Specify the reason to block your card
                      </MenuItem>
                      {blockATMCardReasonOptions.map((cardoptions, index) => (
                          <MenuItem key={index} value={cardoptions}>
                            {cardoptions}
                          </MenuItem>
                      ))}
                    </Select>
                    <small className={classes.mandatory}>{errors.blockATMCardReason}</small>
                  </FormControl> 
                </CardContent>
                {values.blockATMCardReason && 
                  <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
            </Card>     
            </Col>
            }
            {
              values.digitalServices==='PostOnline Services' &&
              <Col xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.postOnline !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
              <LockResetIcon/>
              <CardContent style={{ marginRight: 'auto' }}>
                <FormControl fullWidth //className={classes.formControl}
                >
                    <label><h6>3. Post Online Services</h6></label>
                    <Select
                      fullWidth
                      error={Boolean(errors.postOnline)}
                      //label="Preferred Branch"
                      name="postOnline"
                      onChange={handleChange}
                      helperText={errors.postOnline}
                      select
                      SelectProps={{ native: true }}
                      value={values.postOnline}
                      variant="outlined"
                      id="elmt"
                      size="small"
                    >
                      <MenuItem key='' value=''>
                      Choose Post Online service.
                      </MenuItem>
                      {postOnlineOptions.map((cardoptions, index) => (
                          <MenuItem key={index} value={cardoptions}>
                            {cardoptions}
                          </MenuItem>
                      ))}
                    </Select>
                    <small className={classes.mandatory}>{errors.postOnline}</small>
                </FormControl>
              </CardContent>
              {values.postOnline && 
                    <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
              }
              </Card>
              </Col>
            }
  
          </Row>
          
          <Row>
            {
              values.digitalServices==='ATM Card Limit Enhancement' &&
              <Col item xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.limitAmount !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
                <LocalAtmIcon/>
                <CardContent style={{ marginRight: 'auto' }}>
                <FormControl fullWidth //className={classes.formControl}
                >
                  <label><h6>4. ATM Card Limit Enhancement (Transaction)</h6></label>
                  <Select
                    error={Boolean(errors.limitAmount)}
                    name="limitAmount"
                    onChange={handleChange}
                    helperText={errors.limitAmount}
                    select
                    SelectProps={{ native: true }}
                    value={values.limitAmount}
                    variant="outlined"
                    id="elmt"
                    size="small"
                    fullWidth
                  >
                    <MenuItem key='' value=''>
                    Choose Your Limit.
                    </MenuItem>
                    {atmCardLimitsOptions.map((cardoptions, index) => (
                        <MenuItem key={index} value={cardoptions.nameValue}>
                          {cardoptions.name}
                        </MenuItem>
                    ))}
                  </Select>
                  <small className={classes.mandatory}>{errors.limitAmount}</small>
                  </FormControl>
                </CardContent>
                {values.limitAmount && 
                    <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
              </Card>
              </Col>
            }
            {
              values.digitalServices==='Post Mobile Services' &&
              <Col item xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.postMobile.length !==0 && classes.activeCard}`} style={{ display: 'flex' }}>
                <AppBlockingIcon/>
                <CardContent style={{ marginRight: 'auto' }}>
                  <label><h6>5. PostMobile Services</h6></label>
                  
                    {postMobileOptions.map((item, index) => (
                      <div key={index}>
                        <input value={item} type="checkbox"
                          className={classes.checkbox}  name="postMobile"  onBlur={handleBlur} onChange={handleChange}/><span>{item}</span>&nbsp;&nbsp;           
                      </div>
                    ))}
                    <small className={classes.mandatory}>{errors.postMobile}</small>
                </CardContent>
                {values.postMobile.length !==0 && 
                    <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
              </Card>
              </Col> 
            }
          </Row>
          <Row>
            {values.digitalServices==='ChequeBooks UGX' &&
              <Col xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.numberOfChequeBooksUGX !=="" && classes.activeCard}`} style={{ display: 'flex' }}>
                <CardContent style={{ marginRight: 'auto' }}>
                <FormControl fullWidth //className={classes.formControl}
                >
                  <label component="legend"><h6>Number Of cheque Leaves For UGX </h6></label>
                  <Select
                    //label= "Number Of cheque Leaves For UGX"
                    margin="normal"
                    error={Boolean(errors.numberOfChequeBooksUGX)}
                    name="numberOfChequeBooksUGX"
                    onChange={handleChange}
                    helperText={errors.numberOfChequeBooksUGX}
                    select
                    SelectProps={{ native: true }}
                    value={values.numberOfChequeBooksUGX}
                    variant="outlined"
                    id="elmt"
                    size="small"
                    fullWidth
                  >
                      <MenuItem key='' value="">
                      Number of cheque leaves for Ugandan Shillings
                      </MenuItem>
                      {chequebooksOptions.map((cardoptions, index) => (
                          <MenuItem key={index} value={cardoptions}>
                            {cardoptions}
                          </MenuItem>
                      ))}
                  </Select>
                  <small className={classes.mandatory}>{errors.numberOfChequeBooksUGX}</small>
                  </FormControl>
                  {/*<FormControl fullWidth >
                  <TextField
                    className='customTextField'
                    fullWidth
                    error={Boolean(touched.emailAddress && errors.emailAddress)}
                    helperText={touched.emailAddress && errors.emailAddress}
                    label= "Account Number for UGX Currency"
                    placeholder='UGX account number'
                    type="text"
                    margin="normal"
                    name="emailAddress"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.emailAddress}           
                    variant="outlined"
                    size="small"
                    required
                  />
                      </FormControl>*/}
                </CardContent>
                {values.numberOfChequeBooksUGX !=="" && 
                    <VerifiedIcon className={classes.icon} style={{width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
              </Card>
              </Col>
            }
            {values.digitalServices==='ChequeBooks KES' &&
              <Col item xs={12} md={12} >  
                    <Card className={`${classes.selectCard} ${values.numberOfChequeBooksKES !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
                      <CardContent style={{ marginRight: 'auto' }}>
                        <FormControl fullWidth //className={classes.formControl}
                        >
                          <label component="legend"><h6>Number Of cheque Leaves For KES </h6></label>
                            <Select
                                //label="Number Of cheque Leaves For KES"
                                margin="normal"
                                error={Boolean(errors.numberOfChequeBooksKES)}
                                name="numberOfChequeBooksKES"
                                onChange={handleChange}
                                //disable this option when the check books currency is not selected
                                //disabled={!values.chequebookscurrency.find((currency) => currency === 'KES')==true}
                                //required={values.chequebookscurrency.find((currency) => currency === 'KES')==true}
                                helperText={errors.numberOfChequeBooksKES}
                                select
                                SelectProps={{ native: true }}
                                value={values.numberOfChequeBooksKES}
                                variant="outlined"
                                id="elmt"
                                size="small"
                                fullWidth
                            >
                                <MenuItem key='' value=''>
                                Number of cheque leaves for Kenyan Shillings
                                </MenuItem>
                                {chequebooksOptions.map((cardoptions, index) => (
                                    <MenuItem key={index} value={cardoptions}>
                                      {cardoptions}
                                    </MenuItem>
                                ))}
                            </Select>
                            <small className={classes.mandatory}>{errors.numberOfChequeBooksKES}</small>
                        </FormControl>
                      </CardContent>
                      {values.numberOfChequeBooksKES !=='' && 
                      <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                      }
                    </Card>
              </Col>
            }
            {values.digitalServices==='ChequeBooks USD' &&
              <Col xs={12} md={12}>
                <Card className={`${classes.selectCard} ${values.numberOfChequeBooksUSD !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
                {/*<h6><b>4. ATM Card Limit Enhancement (Transaction) in Millions </b></h6>*/}
                <CardContent style={{ marginRight: 'auto' }}>
                <FormControl fullWidth //className={classes.formControl}
                >
                  <label component="legend"><h6>Number Of cheque Leaves For USD </h6></label>
                  <Select
                    //label="Number Of cheque Leaves For USD"
                    margin="normal"
                    error={Boolean(errors.numberOfChequeBooksUSD)}
                    name="numberOfChequeBooksUSD"
                    onChange={handleChange}
                    helperText={errors.numberOfChequeBooksUSD}
                    select
                    SelectProps={{ native: true }}
                    value={values.numberOfChequeBooksUSD}
                    variant="outlined"
                    id="elmt"
                    size="small"
                    fullWidth
                  >
                      <MenuItem key='' value=''>
                      Number of cheque leaves for USD
                      </MenuItem>
                      {chequebooksOptions.map((cardoptions, index) => (
                          <MenuItem key={index} value={cardoptions}>
                            {cardoptions}
                          </MenuItem>
                      ))}
                  </Select>
                  <small className={classes.mandatory}>{errors.numberOfChequeBooksUSD}</small>
                  </FormControl>
                </CardContent>
                {values.numberOfChequeBooksUSD !=='' && 
                    <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
                </Card>
              </Col>
            }
          </Row>

          <Row>
            {values.digitalServices==='ChequeBooks EUR' &&
              <Col xs={12} md={12}>
                <Card className={`${classes.selectCard} ${values.numberOfChequeBooksEUR !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
                {/*<h6><b>4. ATM Card Limit Enhancement (Transaction) in Millions </b></h6>*/}
                <CardContent style={{ marginRight: 'auto' }}>
                <FormControl fullWidth //className={classes.formControl}
                >
                  <label component="legend"><h6>Number Of cheque Leaves For EUR </h6></label>
                  <Select
                    //label="Number Of cheque Leaves For EUR"
                    margin="normal"
                    error={Boolean(errors.numberOfChequeBooksEUR)}
                    name="numberOfChequeBooksEUR"
                    onChange={handleChange}
                    helperText={errors.numberOfChequeBooksEUR}
                    select
                    SelectProps={{ native: true }}
                    value={values.numberOfChequeBooksEUR}
                    variant="outlined"
                    id="elmt"
                    size="small"
                    fullWidth
                  >
                      <MenuItem key='' value=''>
                      Number of cheque leaves for EUR
                      </MenuItem>
                      {chequebooksOptions.map((cardoptions, index) => (
                          <MenuItem key={index} value={cardoptions}>
                            {cardoptions}
                          </MenuItem>
                      ))}
                  </Select>
                  <small className={classes.mandatory}>{errors.numberOfChequeBooksEUR}</small>
                  </FormControl>
                </CardContent>
                {values.numberOfChequeBooksEUR !=='' && 
                    <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
                }
                </Card>
              </Col>
            }
            {
              values.digitalServices==='ChequeBooks GBP' &&
              <Col xs={12} md={12}>
              <Card className={`${classes.selectCard} ${values.numberOfChequeBooksGBP !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
              {/*<h6><b>4. ATM Card Limit Enhancement (Transaction) in Millions </b></h6>*/}
              <CurrencyPoundIcon/>
              <CardContent style={{ marginRight: 'auto' }}>
              <FormControl fullWidth //className={classes.formControl}
              >
                <label component="legend"><h6>Number Of cheque Leaves For GBP </h6></label>
                <Select
                  //label="Number Of cheque Leaves For GBP"
                  margin='normal'
                  error={Boolean(touched.numberOfChequeBooksGBP && errors.numberOfChequeBooksGBP)}
                  name="numberOfChequeBooksGBP"
                  onChange={handleChange}
                  helperText={errors.numberOfChequeBooksGBP}
                  select
                  SelectProps={{ native: true }}
                  value={values.numberOfChequeBooksGBP}
                  variant="outlined"
                  id="elmt"
                  size="small"
                  fullWidth
                >
                    <MenuItem key='' value=''>
                    Number of cheque leaves for GBP
                    </MenuItem>
                    {chequebooksOptions.map((cardoptions, index) => (
                        <MenuItem key={index} value={cardoptions}>
                          {cardoptions}
                        </MenuItem>
                    ))}
                </Select>
                <small className={classes.mandatory}>{errors.numberOfChequeBooksGBP}</small>
                </FormControl>
              </CardContent>
              {values.numberOfChequeBooksGBP !=='' && 
                  <VerifiedIcon className={classes.icon} style={{width: '30px', height: '30px', objectFit: 'fill' }}/>
              }
              </Card>
            </Col>
            }

          </Row>
          <Row>
          {values.digitalServices==='Stop Payment' &&
            <Col>
            <p><b>Stop Payment</b></p>
            <Card className={`${classes.selectCard} ${values.chequeNumberRange !=='' && values.stoppaymenttime !== '' && values.stopPaymentReason !== '' && classes.activeCard}`} style={{ display: 'flex' }}>
              <BlockIcon/>
              <CardContent style={{ marginRight: 'auto'}}>
              <Row>
                <Col item xs={12} md={6}>
                <label component="legend"><h6>Cheque Number or range </h6></label>
                <FormControl fullWidth //className={classes.formControl}
                >
                {/*<FormLabel component="legend"><h6><b>Cheque Number or range</b></h6></FormLabel>*/}
                <TextField
                  error={Boolean(errors.chequeNumberRange)}
                  helperText={errors.chequeNumberRange}
                  //label= "Cheque Number or range"
                  margin="normal"
                  type="text"
                  name="chequeNumberRange"
                  placeholder="Cheque number range"
                  variant="outlined"
                  onBlur={handleBlur} 
                  onChange={handleChange}
                  value={values.chequeNumberRange}
                  size="small"
                >
                </TextField>
                </FormControl>
                </Col>
                <Col item xs={12} md={6}>
                  <FormControl fullWidth>
                  <label component="legend"><h6>Time to stop this payment</h6></label>
                  <TextField            
                  error={values.chequeNumberRange === "" ? null : Boolean(errors.stoppaymenttime)}
                  helperText={touched.stoppaymenttime && errors.stoppaymenttime}
                  //label= "Time to Stop Payment"
                  type="time"
                  margin="normal"
                  name="stoppaymenttime"
                  disabled={values.chequeNumberRange===''}
                  required={values.chequeNumberRange !== ''}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.stoppaymenttime}
                  size="small"
                  variant="outlined"
                  />
                  </FormControl>
                </Col>
                <Col item xs={12} md={6}>
                  <label component="legend"><h6>Reason to stop this payment</h6></label>
                  <FormControl fullWidth //className={classes.formControl}
                  >
                  <Select
                    fullWidth
                    margin="normal"
                    //error={touched.stopPaymentReason && Boolean(errors.stopPaymentReason)}
                    error={values.chequeNumberRange === '' ? null : Boolean(errors.stopPaymentReason)}
                    //error={values.chequeNumberRange == "" ? null : Boolean(touched.stopPaymentReason && errors.stopPaymentReason)}
                    //error={Boolean(touched.stopPaymentReason && errors.stopPaymentReason)}
                    helperText={touched.stopPaymentReason && errors.stopPaymentReason}
                    name="stopPaymentReason"
                    onChange={handleChange}
                    select
                    SelectProps={{ native: true }}
                    disabled={values.chequeNumberRange===''}
                    required={values.chequeNumberRange !== ''}
                    value={values.stopPaymentReason}
                    variant="outlined"
                    id="elmt"
                    size="small"
                  >
                  <MenuItem
                    key=''
                    value=''
                    //disabled
                  >
                    Select Reason (why you are stopping this payment?)
                  </MenuItem>
                  {stoppayReasons && stoppayReasons.map((reason, index) => (
                    <MenuItem
                      key={index}
                      value={reason}
                    >
                      {reason}
                    </MenuItem>
                  ))}
                  </Select>
                  <small><ErrorMessage name="stopPaymentReason"/></small>
                  </FormControl>
                  </Col>
              </Row>
              </CardContent>
              {values.chequeNumberRange !=='' && values.stoppaymenttime !== '' && values.stopPaymentReason !== '' &&
                  <VerifiedIcon className={classes.icon} style={{ width: '30px', height: '30px', objectFit: 'fill' }}/>
              }
            </Card>
            </Col>
          }
          </Row>
          </div>
      </div>
    </div>
      <br/>
      {(values.postbankDebitCard ||values.numberOfChequeBooksUGX ||values.numberOfChequeBooksKES
      ||values.numberOfChequeBooksUSD ||values.numberOfChequeBooksEUR || values.numberOfChequeBooksGBP) &&
        <Row>        
        <Col>
        <FormControl fullWidth>
        <label component="legend">Branch of Application<span className={classes.mandatory} >&nbsp;*</span></label>
          <Select
            fullWidth
            error={Boolean(errors.branchOfApplication)}
            //label="Preferred Branch"
            name="branchOfApplication"
            onChange={handleChange}
            onBlur={handleBlur}
            required
            margin='normal'
            helperText={errors.branchOfApplication}
            select
            SelectProps={{ native: true }}
            value={values.branchOfApplication}
            disabled={values.numberOfChequeBooksUGX===null && values.numberOfChequeBooksKES===null && values.numberOfChequeBooksUSD===null
            && values.numberOfChequeBooksEUR===null && values.numberOfChequeBooksGBP===null && values.postbankDebitCard===""}
            variant="outlined"
            id="elmt"
            size="small"
            //adding the prop to change the size of the text field
          >
            <MenuItem
              key=''
              value=''
              //disabled
            >
              Choose a Preferred Branch (Where you would like to pick your Cheque Books from /)
            </MenuItem>
            {branches && branches.data.map((branch, index) => (
              <MenuItem
                key={index}
                value={branch.SOL_DESC}
              >
                {branch.SOL_DESC}
              </MenuItem>
            ))}
          </Select>
          <div className={classes.policyError}>{errors.branchOfApplication}</div>
        </FormControl>  
        </Col>
        </Row>
      }<br/>

      <Row>
        <Col>
        <Alert severity="warning" className={classes.snackFont}
          style={{
            //backgroundColor: "#FFCC00", 
            color:"#000000"
          }}>
        We guarantee the accuracy of the information submitted on this application. I/We undertake to indemnify and keep the bank at 
        all times indemnified from and against any legal consequences arising from reliance on my/our instructions or submissions.
        </Alert>
        </Col>
      </Row><br/>
      {/*<Row>
        <Col>
        <FormControl fullWidth>
        <Alert severity="info" className={classes.snackFont}>
          <em><small>Write Your Signature in the space below (Two or more people can sign here)</small></em>
        </Alert>
            <Card className={`${classes.selectCard}`}>
              <CardContent style={{ marginRight: '5px',marginLeft: '5px'}}>
                <SignatureCanvas 
                ref={signatureRef}
                penColor="blue" 
                canvasProps={{ width: 900, height: 100 }} 
                onEnd={handleSendSignature} 
                onBegin={handleSendSignature}
                onChange={handleSendSignature && handleChange}
                onBlur={handleBlur}
                name="digitalSignatureValueHolder"
                value={values.digitalSignatureValueHolder}
                required
                />
                
                <Button onClick={clearSignature}>Clear Signature</Button>
                <div className={classes.mandatory}>{signatureRefValue==="" && <small>Signature is required</small>}</div>

                <div>
      </div>
              </CardContent>
            </Card>
          </FormControl>
        </Col>

        </Row><br/>*/}
      <Row>
      <Col>
        <Alert severity="warning" className={classes.snackFont} 
          style={{
            //backgroundColor: "grey", color:"#000000"
            color: 'black'
          }}>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          onClick={handleTermsCheck}
          className={classes.checkbox} 
          name="policy" onBlur={handleBlur} 
          //inputProps={{ 'aria-label': 'primary checkbox' }}
        /> 
        I guarantee that the accuracy of my contacts (mobile/email) provided above and consent to the use of my Phone No, and Email above for the bank's digital services.
        I accordingly agree to hold the bank harmless from any loss/claims that may arise should the bank rely on them.
        </Alert>
      &nbsp;
      <small className={classes.policyError}><ErrorMessage name="policy" /></small>
      </Col>
      </Row>

      <Row>
        <Col>
        <Button fullWidth type="button" onClick={previewDialogClick } variant="contained"   
        disabled={!(dirty && isValid) || isSubmitting} 
        color="secondary"
        //className={classes.details}
        >
          Preview & Submit My Request</Button>
        </Col>
      </Row>
      <Row>

      {/**Add an alert that displays the errors why the form can't submit */}

      {/** This JSX handles the dialog for the preview*/}
      <Dialog
        fullScreen={true}
        open={previewOpen}
        onClose={handleClose}
        style={{margin: 0}}
      >
        <DialogActions
         style={{backgroundColor:'#61dafb',marginLeft: '25px', marginRight: '20px', borderRadius:'4px',    justifyContent: 'space-between', 
         alignItems: 'center'}}        
        >
        <Button onClick={handlePreviewClose} 
        style={{ color:'#FF0000', justifyContent: 'flex-start'}}>Back to Edit</Button>       
        {loading ?(
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress />
            <Typography variant="body2" color="textSecondary" style={{ marginLeft: '10px'}}>
              Submission in progress Please wait...
            </Typography>
          </div>):(<></>)
        }
        <div style={{justifyContent: 'flex-end'}}>
        <LoadingButton type="button"
            onClick={handleSubmit}
            loading={loading}
            loadingIndicator={<CircularProgress color="inherit" size={30} />}
            variant="outlined"
            color="primary"
            sx={{ backgroundColor: colors.lime[500], color:'#ffffff'}}
        >Submit My Request
        </LoadingButton>
        </div>
        </DialogActions>

        <DialogContent>
        <Row>
        <Col xs={12} md={6}>
        <Typography fullwidth className={classes.formValue} style={{ display: 'flex', alignItems: 'center' }}>
        <span><small>Please copy the reference number (It will also be shared via SMS and Email)</small></span>
        <textarea  className={classes.highlight} variant="h6" ref={textAreaRef} value={values.formID}></textarea>
        {/*<TouchAppIcon style={{ marginRight: '10px', position: 'relative', top: '1px' }}/>*/}
        <Tooltip title="Click to copy Request ID" arrow placement="top">
          <FileCopyIcon onClick={copyCodeToClipboard} />                    
        </Tooltip>
      </Typography>
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                open={snackOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnack}
                message=""
                key="topcenter"
                action={
                  <React.Fragment>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnack}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </React.Fragment>
                }
              >
                <Alert onClose={handleCloseSnack} severity="info" variant="filled" className={classes.snackFont}>
                  FORM ID has been Copied Succesfully!
                </Alert>
              </Snackbar>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            type="text"
            startAdornment={<InputAdornment position="start">Account Name <b>&nbsp;{values.accountName}</b></InputAdornment>}
            readOnly
        />
          </FormControl>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            startAdornment={<InputAdornment position="start">Account Number &nbsp;<b>{values.accountNumber}</b></InputAdornment>}
            readOnly
        />
        </FormControl>
          </Col>
        </Row>

        <Row>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            startAdornment={<InputAdornment position="start">ID Number &nbsp;<b>{values.idNumber}</b></InputAdornment>}
            readOnly
         />
          </FormControl>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            startAdornment={<InputAdornment position="start">Branch Of Application &nbsp;<b>{values.branchOfApplication}</b></InputAdornment>}
            readOnly
        />
          </FormControl>
          </Col>
        </Row>

        <Row>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            startAdornment={<InputAdornment position="start">Email Address &nbsp;<b>{values.emailAddress}</b></InputAdornment>}
            readOnly
        />
          </FormControl>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <OutlinedInput className={classes.readonly}
            size="small"
            startAdornment={<InputAdornment position="start">Mobile Phone Number &nbsp;<b>{values.countryCode}{values.mobilePhoneNumber}</b></InputAdornment>}
            readOnly
         />
          </FormControl>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormControl fullWidth sx={{ m: 1 }} >
              <p>{values.idType} Front Image</p>
            {previewFrontImage && 
              <CardMedia
                component="img"
                src={previewFrontImage}
                alt="Front image"
                style={{ width: '300px', height: '150px', objectFit: 'fill' }}
              />                  
            }
            </FormControl>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }}>
          <p>{values.idType} Back Image</p>
          {previewBackImage && 
            <CardMedia
              component="img"
              src={previewBackImage}
              alt="Back image"
              style={{ width: '300px', height: '150px', objectFit: 'fill' }}
            />                  
          }
          </FormControl>
          </Col>
          <Col>
          <FormControl fullWidth sx={{ m: 1 }}>
          <p>Digital Signature</p>
          {/*previewDigitalSignature && 
            <CardMedia
              component="img"
              src={previewDigitalSignature}
              alt="Digital Signature"
              style={{ width: '300px', height: '150px', objectFit: 'fill' }}
            />                  
        */}
        {
        previewSignatureImage && 
            <CardMedia
              component="img"
              src={previewSignatureImage}
              alt="Digital Signature"
              style={{ width: '300px', height: '150px', objectFit: 'fill' }}
            />  
        }
          </FormControl>
          </Col>
        </Row>
       {/**All the services selected start here */}
        <Row alignItems="center" justifyContent="center">
          <Col>
          <Button variant="contained" fullWidth className={classes.customer_header}>HERE ARE SERVICES YOU ARE ABOUT TO REQUEST</Button>
          </Col>
        </Row>
        <Row>
        {values.postbankDebitCard &&
          <Col>          
              <FormControl fullWidth sx={{ m: 1 }} >
                  <TextField className={classes.readonly}
                    label="PostBank Debit Card"
                    multiline
                    size="small"
                    //startAdornment={<InputAdornment position="start">Postbank DebitCard &nbsp;<b>{values.postbankDebitCard}</b></InputAdornment>}
                    readOnly
                    value={values.postbankDebitCard}
                  />
              </FormControl>          
          </Col>
        }
        {values.postMobile.length > 0 &&
          <Col>
          <FormControl fullWidth sx={{ m: 1 }}>
            <TextField className={classes.readonly}
            label="Post Mobile"
            multiline
            size="small"
            //startAdornment={<InputAdornment position="start">Post Mobile&nbsp;{values.postMobile}</InputAdornment>}
            value={values.postMobile}
            readOnly
          />
          </FormControl>
          </Col>
        }
        </Row>
        <Row>
        {values.postOnline &&
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <TextField className={classes.readonly}
            label="Post Online"
            multiline
            size="small"
            value={values.postOnline}
            //startAdornment={<InputAdornment position="start">Post Online&nbsp;<b>{values.postOnline}</b></InputAdornment>}
            readOnly
        />
          </FormControl>
          </Col>
        }
        {values.blockATMCardReason &&
          <Col>
          <FormControl fullWidth sx={{ m: 1 }} >
            <TextField className={classes.readonly}
            label="Block ATM Card"
            multiline
            size="small"
            value={values.blockATMCardReason}
            //startAdornment={<InputAdornment position="start">Block ATM Card Reason &nbsp;<b>{values.blockATMCardReason}</b></InputAdornment>}
            readOnly
        />
          </FormControl>
          </Col>
        }
        </Row>
        <Row>
          {values.limitAmount &&
            <Col>
            <FormControl fullWidth sx={{ m: 1 }} >
              <TextField className={classes.readonly}
              label="ATM Card Limit Enhancement"
              //multiline
              size="small"
              value={values.limitAmount}
              //startAdornment={<InputAdornment position="start">ATM Card Limit Enhancement<b>{values.limitAmount}</b></InputAdornment>}
              readOnly
            />
            </FormControl>
            </Col>
          }
          {values.numberOfChequeBooksUGX&&
           <Col>
           <FormControl fullWidth sx={{ m: 1 }}>
             <TextField className={classes.readonly}
             label="ChequeBooks UGX"
             //multiline
             size="small"
             value={values.numberOfChequeBooksUGX}
             readOnly
             />
           </FormControl>
           </Col>
          }
        </Row>
        <Row>
          {values.numberOfChequeBooksKES&&
           <Col>
           <FormControl fullWidth sx={{ m: 1 }}>
           <TextField className={classes.readonly}
             label="ChequeBooks KES"
             //multiline
             size="small"
             value={values.numberOfChequeBooksKES}
             readOnly
             />
           </FormControl>

           </Col>
          }
          {values.numberOfChequeBooksUSD&&
           <Col>
           <FormControl fullWidth sx={{ m: 1 }}>
             <TextField className={classes.readonly}
             label="ChequeBooks USD"
             //multiline
             //input="textarea"
             size="small"
             value={values.numberOfChequeBooksUSD}
             readOnly
             />
           </FormControl>
           </Col>
          }
        </Row>
        <Row>
          {values.numberOfChequeBooksEUR&&
           <Col>
           <FormControl fullWidth sx={{ m: 1 }}>
             <TextField className={classes.readonly}
             label="ChequeBooks EUR"
             //multiline
             input="textarea"
             size="small"
             value={values.numberOfChequeBooksEUR}
             readOnly
             />
           </FormControl>
           </Col>
          }
          {values.numberOfChequeBooksGBP&&
           <Col>
           <FormControl fullWidth sx={{ m: 1 }}>
             <TextField className={classes.readonly}
             label="ChequeBooks GBP"
             //multiline
             size="small"
             value={values.numberOfChequeBooksGBP}
             readOnly
             />
           </FormControl>
           </Col>
          }
        </Row>
        <Row>
          {values.chequeNumberRange &&
            <Col>
            <FormControl fullWidth sx={{ m: 1 }} >
              <TextField className={classes.readonly}
              //multiline
              label="Cheque Books Range to be blocked Block"
              size="small"
              value={values.chequeNumberRange}
              //startAdornment={<InputAdornment position="start">Cheque Books Range to be blocked Block &nbsp;<b>{values.chequeNumberRange}</b></InputAdornment>}
              readOnly
              />
            </FormControl>
            </Col>
          }
          {values.chequeNumberRange &&
            <Col>
            <FormControl fullWidth sx={{ m: 1 }} >
              <TextField className={classes.readonly}
              //multiline
              label="Reason to stop payment"
              size="small"
              value={values.stopPaymentReason}
              //startAdornment={<InputAdornment position="start">Cheque Books Range to be blocked Block &nbsp;<b>{values.chequeNumberRange}</b></InputAdornment>}
              readOnly
              />
            </FormControl>
            </Col>
          }
        </Row>
        
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen={true}
        open={open}
        onClose={handleClose}
      >       
        <DialogContent>

        <div>
    <Typography
      color="textPrimary"
      variant="h5"
      className={classes.formTitle}
      flexGrow={2}
    >
    Privacy Statement of PostBank Uganda Limited<span className={classes.value}></span>
    </Typography>
    {
      PrivacyInformation.map((info) => (
        <Grid item xs={12} md={12} key={info.id}>
        <Alert variant="filled"style={{backgroundColor: "#ffffff", color: "#039BE5", fontSize:16}}><b>{info.subject}</b></Alert>
          <Card>
            <CardContent>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.one}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.two}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.three}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.four}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.five}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.six}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.seven}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eight}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.nine}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.ten}</Typography>
            <Typography variant="h6" style={{ marginBottom: '10px', fontSize: '12px' }}>{info.body.eleven}</Typography>
            </CardContent>
          </Card>
        <br/>
        </Grid>
    ))} 
    </div>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <LoadingButton type="submit"
        onClick={handleCloseAndAccept}
        loading={loading}
        variant="outlined"
        >Accept Terms & Conditions
        </LoadingButton>
        </DialogActions>
      </Dialog>
      </Row>     
  </form>
        )
        }
        }
      </Formik>

    </Grid>   
  );
}

const SelfService = () => {
  //Create a responsive page layout
  return (
    <div>
        <NavbarLower/>
        <SelfServiceContent/>  
        <Footer/>    
    </div>

  );
};
  
export default SelfService;